export default __webpack_public_path__ + "static/media/Mass_09.118a9fb9.png";